import theme from '@styles/theme';

export default {
  contentSection: {
    mb: ['32px', '32px', '48px', '48px', '100px'],
  },
  mainHeader: {
    m: ['36px auto 0px', '36px auto 0px', '52px auto 0px', '75px auto 0px'],
  },
  containerContent: (full = false) => ({
    m: full ? '0' : ['0', '0', '0', '0', '0 26px'],
    letterSpacing: theme.letterSpacings.smallCaps,
    p: {
      fontSize: '16px',
      lineHeight: '175%',
      letterSpacing: theme.letterSpacings.smallCaps,
      m: '0 0 16px',
    },
    h2: {
      m: ['24px 0', '24px 0', '40px 0 24px', '40px 0 24px'],
    },
    h3: {
      m: ['24px 0', '24px 0', '40px 0 24px', '40px 0 24px'],
    },
    h4: {
      m: ['0 0 24px', '0  0 24p', '40px 0 24px', '40px 0 24px'],
    },
    h5: {
      m: '24px 0 16px',
    },
    h6: {
      m: '24px 0 16px',
    },
    h7: {
      m: '16px 0',
    },
    ul: {
      listStylePosition: 'outside',
      li: {
        position: 'relative',
        listStyle: 'none',
        ':before': {
          content: '"\\2022"',
          position: 'absolute',
          left: '-13px',
        },
      },
    },
    ol: {
      listStylePosition: 'outside',
    },
    li: {
      lineHeight: '175%',
      m: '16px 0 16px 23px',
      p: '0 2px',
    },
    a: {
      textDecoration: 'underline',

      '&:hover': {
        textDecoration: 'underline',
      },
    },
    '.intro': {
      display: 'inline-block',
      color: theme.rawColors.darkGrey500,
      mt: '-32px',
      p: {
        letterSpacing: theme.letterSpacings.smallCaps,
        m: '16px 0 0',
      },
    },
  }),
  mainWrapper: {
    catalog: {
      display: 'grid',
      gridTemplateColumns: ['repeat(1, 1fr)', 'repeat(1, 1fr)', 'repeat(2, 1fr)', 'repeat(2, 1fr)', 'repeat(3, 1fr)'],
      gridGap: '10px',
      gridAutoRows: '1fr',
      m: ['20px 0', '20px 0', '40px 0'],
    },
    image: {
      display: 'flex',
    },
  },
};
